// extracted by mini-css-extract-plugin
export default {"caption":"index_caption_h6bYl"};